module.exports = __webpack_public_path__ + "static/shareFanLand2BG-2257101d7fd5f2bcb1fe70b16c735544.png";